module.exports = __webpack_public_path__ + "static/media/lang6.475e75c6.mp3";